import { setTheme } from "theme/default/setTheme";

export const color_rgba_0_0_0_10 = setTheme(({ theme }) => theme.colors.setColor_rgba_0_0_0_10);
